<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <h2 *ngIf="form?.value?.displayName">{{ form?.value?.displayName }} [{{ form?.value?.code }}]</h2>
      </div>

      <div>
        <action-bar
          [showSave]="true"
          [showSleep]="form?.value?.memberId"
          [showDelete]="form?.value?.memberId"
          [isSleepingMode]="form?.value?.isSleepingMode"
          (onSave)="clickSave(form?.value)"
          (onSleep)="clickSleep(form?.value)"
          (onDelete)="clickDelete(form?.value?.memberId)"></action-bar>
      </div>
    </div>
    <div>
      <div class="identification">
        <h3 class="title-margin-top">{{ 'common_section_identification' | translate }}</h3>
        <mat-card>
          <div class="row row-align-items">
            <div class="col-2">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
                <input matInput formControlName="code" minlength="2" maxlength="10" required />
                <mat-error *ngIf="formCrls.code.invalid">{{ 'member_error_code_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'common_field_label' | translate }}</mat-label>
                <input matInput formControlName="displayName" maxlength="256" required />
                <mat-hint align="end">{{ form.value.displayName?.length || 0 }} / 256</mat-hint>
                <mat-error *ngIf="formCrls.displayName.invalid">{{ 'member_error_label_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field>
                <mat-label>{{ 'common_field_parent' | translate }}</mat-label>
                <input matInput [value]="form?.value?.parent" disabled />
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field>
                <mat-label>{{ 'common_field_status' | translate }}</mat-label>
                <mat-select formControlName="memberStatus" required>
                  <mat-option value="Actif"> {{ 'member_status_active' | translate }} </mat-option>
                  <mat-option value="Passif"> {{ 'member_status_passive' | translate }} </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field>
                <mat-label>{{ 'member_field_type' | translate }}</mat-label>
                <mat-select formControlName="profileType" required>
                  <mat-option *ngFor="let p of profileTypes" [value]="p.value"> {{ p.label | translate }} </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>

      <div class="fdes-scope" *ngIf="acuView">
        <div class="seve-card">
          <div class="seve-card__head">
            <span class="seve-eyebrow-ic seve-eyebrow-ic--green"><mat-icon>eco</mat-icon></span>
            <span class="seve-eyebrow seve-eyebrow--green">{{ 'member_rdf_section_title' | translate }}</span>
          </div>
          <div class="seve-card__body">
            <div class="fdes-rdf">
              <label class="seve-switch fdes-rdf__switch">
                <input type="checkbox" formControlName="isRdfAdherent" />
                <span class="fdes-rdf__text">
                  <span class="fdes-rdf__title">{{ 'member_rdf_switch_title' | translate }}</span>
                  <span class="fdes-rdf__subtitle">{{ 'member_rdf_switch_subtitle' | translate }}</span>
                </span>
              </label>
              <span class="seve-badge seve-badge--success fdes-rdf__badge" *ngIf="formCrls.isRdfAdherent?.value"><span class="seve-badge__dot"></span>{{ 'member_rdf_badge' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
